import { profileService } from '../../profile/service';
import { useEffect, useState } from 'react';
import { IsPhysiqueAuthorized } from '../../../utils/auth';

export default function usePatientInfo() {
  const [patientInfo, setPatientInfo] = useState(null);

  useEffect(() => {
    if (IsPhysiqueAuthorized())
      profileService.getPatientInfo().then((patient) => {
        setPatientInfo(patient);
        localStorage.setItem('membershipId', patient.membership?.program.id || '');
        localStorage.setItem('membershipImage', patient.membership?.program.imageData || '');
      });
  }, []);

  return patientInfo;
}
